export default __webpack_public_path__ + "static/media/CustomsInspection.edb1eb37.svg";